module.exports = __webpack_public_path__ + "img/pencil-01.7b9158a9.svg";